export default __webpack_public_path__ + "static/media/Priceline.2ad85b45.svg";